import axios from "axios";
import { ENDPOINT } from "constants/environment";
import { consoleLog } from "helpers";
import { decryptData } from "helpers";
import { encryptData } from "helpers";
import { getHeaderConfig } from "helpers";

export const getFilterDataAPI = async (payload, isLoading, accessJWT) => {
  try {
    isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.post(
      `${ENDPOINT}/app/v1/filterData`,
      encryptData(payload),
      config
    );
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData && parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      consoleLog([parsedResponseData, "response"]);
      return parsedResponseData?.data;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error fetching filter data:", error);
    return null;
  }
};
